const stringToFloat = (value?: string) => {
  if (!value) {
    return undefined;
  }

  const float = parseFloat(value);

  if (Number.isNaN(float)) {
    return undefined;
  }

  return float;
};

export default stringToFloat;
